/** percentile_cont(0.5): mean of the two middle values for an even count. */
export const median = (values: readonly number[]): number | null => {
  if (!values.length) return null;
  const s = [...values].sort((a, b) => a - b);
  const m = Math.floor(s.length / 2);
  return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2;
};
/** Half away from zero (Postgres numeric round). */
export const round = (x: number, digits: number): number => {
  const f = 10 ** digits;
  return Math.sign(x) * (Math.round((Math.abs(x) + Number.EPSILON) * f) / f);
};
export const ratio = (
  num: number,
  den: number,
  digits: number,
): number | null => (den > 0 ? round(num / den, digits) : null);
